import { FC } from 'react';
import BestBlockIcon1 from '../../static/assets/homepage/best-block-icon-1.svg';
import BestBlockIcon2 from '../../static/assets/homepage/best-block-icon-2.svg';
import BestBlockIcon3 from '../../static/assets/homepage/best-block-icon-3.svg';
import BestBlockIcon4 from '../../static/assets/homepage/best-block-icon-4.svg';
import BestBlockIcon5 from '../../static/assets/homepage/best-block-icon-5.svg';
import BestBlockIcon6 from '../../static/assets/homepage/best-block-icon-6.svg';
import './HomeBest.scss';

const HomeBest: FC = () => (
	<section className="home-best home-section">
		<div className="internal-wrapper">
			<div className="home-best__internal-wrapper">
				<div className="home-section-header">
					<h2 className="home-best__title title-section title">
						Train what you really need!
					</h2>
					<p className="home-plans__subtitle subtitle-section">
						No more placeholders, only real world cases
					</p>
				</div>
				<div className="home-best__items-wrapper">
					<div className="home-best__item">
						<div className="home-best__title-wrapper">
							<img
								className="home-best__item-icon"
								src={BestBlockIcon6}
								alt="Codeway.TODAY"
							/>
							<h3 className="home-best__item-title title title-small">
								Real Backend APIs
							</h3>
						</div>
						<div className="home-best__item-text text-block">
							<p>
								Get hands-on with full-scale APIs designed for building Frontend
								applications. You will develop a real web applications with usage of
								REST apis, WebSockets and GraphQL.
							</p>
						</div>
					</div>

					<div className="home-best__item">
						<div className="home-best__title-wrapper">
							<img
								className="home-best__item-icon"
								src={BestBlockIcon1}
								alt="Codeway.TODAY"
							/>
							<h3 className="home-best__item-title title title-small">
								Product design
							</h3>
						</div>
						<div className="home-best__item-text text-block">
							<p>
								Every project comes with product design specifications and step-by-step
								task guidance, mirroring how you’d work in a team at a real company.
								Build projects with clarity and purpose, refining your skills as you go.
							</p>
						</div>
					</div>
					<div className="home-best__item">
						<div className="home-best__title-wrapper">
							<img
								className="home-best__item-icon"
								src={BestBlockIcon2}
								alt="Codeway.TODAY"
							/>
							<h3 className="home-best__item-title title title-small">
								Real world use cases
							</h3>
						</div>
						<div className="home-best__item-text text-block">
							<p>
								Our APIs are crafted to address genuine challenges: user authentication,
								pagination, infinite scroll, multi-user interactions, real-time
								WebSocket messaging, GraphQL requests, and more. Practice the tasks
								you’ll face in a professional environment.
							</p>
						</div>
					</div>
					<div className="home-best__item">
						<div className="home-best__title-wrapper">
							<img
								className="home-best__item-icon"
								src={BestBlockIcon4}
								alt="Codeway.TODAY"
							/>
							<h3 className="home-best__item-title title title-small">UI/UX design</h3>
						</div>
						<div className="home-best__item-text text-block">
							<p>
								Sharpen your Frontend development skills using realistic Figma and Pixso
								mockups, carefully aligned with each project’s product design. These
								mockups allow you to focus on implementing UI and UX elements, giving
								you practical experience with designs as you build polished, real-world
								applications.
							</p>
						</div>
					</div>
					<div className="home-best__item">
						<div className="home-best__title-wrapper">
							<img
								className="home-best__item-icon"
								src={BestBlockIcon3}
								alt="Codeway.TODAY"
							/>
							<h3 className="home-best__item-title title title-small">
								Affordable pricing
							</h3>
						</div>
						<div className="home-best__item-text text-block">
							<p>
								Starting at just $14 per month, our pricing ensures quality without
								compromise. With resources to guide you independently, you won’t need a
								teacher to progress – but support is here when you need it.
							</p>
						</div>
					</div>

					<div className="home-best__item">
						<div className="home-best__title-wrapper">
							<img
								className="home-best__item-icon"
								src={BestBlockIcon5}
								alt="Codeway.TODAY"
							/>
							<h3 className="home-best__item-title title title-small">
								Сonsultation services
							</h3>
						</div>
						<div className="home-best__item-text text-block">
							<p>
								We offer three key types of consultations: mock interviews, homework
								assessments review, and career mentorship. You can request a
								consultation anytime you need a confidence boost or want to gauge your
								progress on this journey.
							</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
);

export default HomeBest;
